jQuery.noConflict();
jQuery(document).ready(function($) {
  let isOverDropdown = false;
  $(document).on('click', '*[data-toggle="dropdown"]', function(event){
    event.preventDefault();
    $('#' + $(this).data('target')).toggleClass('shown');
  });
  $('body').click(function(){
    if(!isOverDropdown){
      $('.soff_dropdown').removeClass('shown');
    }
  })
  $('.soff_dropdown').hover(function(){
    isOverDropdown = true;
  }, function(){
    isOverDropdown = false;
  });
  $(document).on('mouseenter', '*[data-toggle="dropdown"]', function(){
    isOverDropdown = true;
  });
  $(document).on('mouseleave', '*[data-toggle="dropdown"]', function(){
    isOverDropdown = false;
  });
});
